import { BTMenu } from "@btnet/core-components/BTMenu";

import { BdsIconArrowUUpRight } from "@buildertrend/components";

import { type ICollapsableControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { EditorControlButton } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/EditorControlButton/EditorControlButton";
import { InputRecaptureHackMenuItem } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/InputRecaptureHack/InputRecaptureHack";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

const extensionId = "history";
const onClick = (editor: IEditor) => {
    editor.tiptapEditor.commands.redo();
};

export const redoControl: ICollapsableControl = {
    key: "redo",
    isControlSupported(supportedExtensions, editor) {
        return (
            supportedExtensions.has(extensionId) && editor.editorState.mode !== "inlineControlsOnly"
        );
    },
    isControlEnabled({ tiptapEditor }) {
        return tiptapEditor.can().redo();
    },
    expandedElement(editor) {
        return (
            <EditorControlButton
                data-testid="redo"
                icon={<BdsIconArrowUUpRight />}
                isToggled={false}
                onClick={() => onClick(editor)}
                disabled={!editor.tiptapEditor.can().redo()}
                friendlyName="Redo"
            />
        );
    },
    collapsedActiveKeys() {
        return [];
    },
    collapsedMenuItem(editor) {
        return (
            <InputRecaptureHackMenuItem
                editor={editor}
                menuComponent={BTMenu.Item}
                key={this.key}
                menuProps={{
                    icon: <BdsIconArrowUUpRight />,
                    onClick: () => onClick(editor),
                    disabled: !editor.tiptapEditor.can().redo(),
                    testid: "redo",
                }}
            >
                Redo
            </InputRecaptureHackMenuItem>
        );
    },
};
